import { useApolloClient } from "@vue/apollo-composable";
import { useAuth } from "@/core/composables/useAuth";
import { USER_ID_LOCAL_STORAGE } from "@/core/constants/local-storage-keys";
import { NON_EMPTY_CARTS_MERGED_SESSION_STORAGE } from "@/core/constants/session-storage-keys";
import { TabsType, reloadAndOpenMainPage, useBroadcast } from "@/shared/broadcast";

export function useSignMeOut(options: { reloadPage?: boolean } = { reloadPage: true }) {
  const { client } = useApolloClient();
  const broadcast = useBroadcast();

  const { unauthorize } = useAuth();

  async function signMeOut() {
    await unauthorize();

    await client.clearStore();

    localStorage.removeItem("locale");
    localStorage.removeItem("currency");
    sessionStorage.removeItem("currency");
    localStorage.removeItem(USER_ID_LOCAL_STORAGE);
    sessionStorage.removeItem(NON_EMPTY_CARTS_MERGED_SESSION_STORAGE);

    if (options.reloadPage) {
      broadcast.emit(reloadAndOpenMainPage, undefined, TabsType.ALL);
    }
  }

  return {
    signMeOut,
  };
}
